import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import LinkColumnItem from './LinkColumnItem';

import styles from './LinkColumn.scss';

const LinkColumn = props => {
    const { viewer, title, items, isClient } = props;

    return (
        <nav>
            <div className={styles.column}>
                <h4 className={styles.title}>{title}</h4>
                {items.map(item => {
                    const CustomComponent = item.CustomComponent;
                    return CustomComponent ? (
                        <CustomComponent
                            key={item.dataTn}
                            {...item}
                            viewer={viewer}
                            isClient={isClient}
                        />
                    ) : (
                        <LinkColumnItem key={item.dataTn} {...item} viewer={viewer} />
                    );
                })}
            </div>
        </nav>
    );
};

LinkColumn.propTypes = {
    viewer: PropTypes.object,
    items: PropTypes.array,
    title: PropTypes.node,
    isClient: PropTypes.bool,
};

export default createFragmentContainer(LinkColumn, {
    viewer: graphql`
        fragment LinkColumn_viewer on Viewer {
            ...SocialLinkRow_viewer
            ...FooterSubscribe_viewer
        }
    `,
});
